var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4163 13.6588V15.6612C12.8168 15.4493 12.1718 15.334 11.4997 15.334C8.32404 15.334 5.74967 17.9084 5.74967 21.084H3.83301C3.83301 16.8498 7.26549 13.4173 11.4997 13.4173C12.1615 13.4173 12.8038 13.5012 13.4163 13.6588ZM11.4997 12.459C8.3228 12.459 5.74967 9.88586 5.74967 6.70898C5.74967 3.53211 8.3228 0.958984 11.4997 0.958984C14.6765 0.958984 17.2497 3.53211 17.2497 6.70898C17.2497 9.88586 14.6765 12.459 11.4997 12.459ZM11.4997 10.5423C13.6176 10.5423 15.333 8.8269 15.333 6.70898C15.333 4.59107 13.6176 2.87565 11.4997 2.87565C9.38176 2.87565 7.66634 4.59107 7.66634 6.70898C7.66634 8.8269 9.38176 10.5423 11.4997 10.5423ZM17.2497 16.2923V13.4173H19.1663V16.2923H22.0413V18.209H19.1663V21.084H17.2497V18.209H14.3747V16.2923H17.2497Z",
    fill: "#2E3031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssign);
export default __webpack_public_path__ + "static/media/assign.f6394c726972f1e3179d26ec7472a6b1.svg";
export { ForwardRef as ReactComponent };